
































import { Prop, Component, Vue } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { RealworksStatusRuleAPI } from '@/api/backend-client'

@Component
export default class RealworksStatusRuleDetail extends Vue {
    @Prop({ required: true }) readonly realworksStatusRuleId!: string
    realworksStatusRule: RealworksStatusRule = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        await this.loadRealworksStatusRule()
        this.loading = false
    }

    async loadRealworksStatusRule(): Promise<void> {
        this.realworksStatusRule = await RealworksStatusRuleAPI.get(this.realworksStatusRuleId, true)
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_realworks_status_rules',
        })
    }
}
